import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { UpdateExpositionNette } from "../../core/model/fournisseuragree/update-exposition-nette";
import { FournisseurAgreeDTO } from "../../core/model/fournisseuragree/fournisseur-agree-dto";
import { FournisseurAgreeService } from "../../core/service/fournisseur-agree.service";

@Component({
  selector: "app-edit-exposition-nette-four-agree",
  templateUrl: "./edit-exposition-nette-four-agree.component.html",
  styleUrls: ["./edit-exposition-nette-four-agree.component.scss"],
})
export class EditExpositionNetteFourAgreeComponent implements OnInit {
  @Input() id;

  updateExpositionNette: UpdateExpositionNette = new UpdateExpositionNette();
  fournisseurAgreeDTO: FournisseurAgreeDTO;
  loading = true;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _fournisseurAgreeService: FournisseurAgreeService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      expositionNette: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.findById(this.id);
  }

  findById(id) {
    this.loading = true;
    this._fournisseurAgreeService.findById(id).subscribe(
      (data) => {
        this.fournisseurAgreeDTO = data;
        this.updateExpositionNette = {
          ...this.updateExpositionNette,
          fournisseurAgreeId: this.fournisseurAgreeDTO.id,
          expositionNette: this.fournisseurAgreeDTO.expositionNette,
        };
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  save(): void {
    this.pressButton = true;
    this._fournisseurAgreeService
      .updateExpositionNette(this.updateExpositionNette)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close(this.updateExpositionNette);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
